export default "/images/boom_coloured.png?773185c92bdb276ca2fc791c89aacfbf";